import { render } from "./GrayBlock.vue?vue&type=template&id=4013e63b&scoped=true"
const script = {}

import "./GrayBlock.vue?vue&type=style&index=0&id=4013e63b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4013e63b"]])

export default __exports__